import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import AppInput from '../../../../common/AppInput';
import Message from '../../../../common/Message';
import { Typography } from '@material-ui/core';
import MotiveTitle from '../../../../views/Contact/Motive/MotiveTitle';
import { useFormStyles } from './styles';
import {
  INFO_GO_MY_ACCOUNT_CHANGE_EMAIL,
  COMPLETE_FORM,
} from '../../../../../constants/texts';
import { textMapper } from '../../../../../helpers/FormHelper';
import { resetGet } from '../../../../../redux/slices/ValidationDniSlice';

const Form = ({ ...props }) => {
  const { state, onData, mobile, motiveId, fields } = props;
  const classes = useFormStyles({ mobile });
  const reduxDispatch = useDispatch();

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  useEffect(() => {
    reduxDispatch(resetGet());
  }, [resetGet]);

  return (
    <React.Fragment>
      <MotiveTitle
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        icon={textMapper.get(motiveId).icon}
        mobile={mobile}
      />

      <Message
        severity="info"
        message={INFO_GO_MY_ACCOUNT_CHANGE_EMAIL}
        fullRounded
      />

      <Typography className={classes.title}>{COMPLETE_FORM}</Typography>

      {fields.map((field, index) => (
        <AppInput
          key={index}
          onChange={handleChange}
          onBlur={() => {}}
          onClick={() => {}}
          disabled={state[field.name]?.disabled || false}
          name={field.name}
          error={state[field.name]?.error || false}
          type={state[field.name]?.type || ''}
          label={state[field.name]?.label || ''}
          required={state[field.name]?.required || false}
          inputAdornment={state[field.name]?.inputAdornment || ''}
          success={state[field.name]?.success || false}
          helperText={state[field.name]?.helper || ''}
          multiline={state[field.name]?.multiline || false}
          rows={state[field.name]?.rows || null}
          value={state[field.name]?.value || ''}
          errorMessage={state[field.name]?.message || ''}
        />
      ))}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  valid: PropTypes.bool,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  fields: PropTypes.array,
};

export default Form;
